import Vue from "vue";
import store from "@/store";
import i18n from "@/i18n";

import mApp from "@/modules/app";
import mDialog from "@/modules/dialog";
import mRest from "@/modules/rest";
import mUtils from "@/modules/utils";
import { ORDER_TYPE } from "@/modules/enums";

export default {
  getStores() {
    return mApp.apiPost(store.getters.doApiUrl + "/v2/getstores", { sessionKey: store.state.appSessionKey });
  },

  getStore(storeSessionKey) {
    return mApp.apiPost(store.getters.doApiUrl + "/getstore", { sessionKey: storeSessionKey });
  },
  
  getStoreHours(payload) {
    let reload = true;

    if (reload) {
      return mApp
        .apiPost(store.getters.doApiUrl + "/v3/getstorehours", {
          sessionKey: store.state.Store.store?.sessionKey,
          orderType: store.state.Order.order.orderType,
          checkOrderLimit: store.getters.checkOrderLimit,
          deliveryMin: store.state.Order.order.deliveryDriveMin,
          scheduleOrderHours: payload?.scheduleOrderHours,
          appKey: store.state.appData?.orderType == "table" ? store.state.appToken?.AppKey : undefined,
          dataId: store.state.appData?.orderType == "table" ? store.state.appToken?.DataId : undefined,
        })
        .then(data => {
          if (data.result == "ok") {
            Vue.set(store.state, "storeHours", data);

            if (data.businessHours)
              Vue.set(store.state.Store.store.info.businessHours, data.currentDay, data.businessHours);
            if (data.orderHours) {
              if (data.orderType == ORDER_TYPE.DINEIN)
                Vue.set(store.state.Store.store.info.dineinHours, data.currentDay, data.orderHours);
              else if (data.orderType == ORDER_TYPE.TAKEOUT)
                Vue.set(store.state.Store.store.info.takeoutHours, data.currentDay, data.orderHours);
              else if (data.orderType == ORDER_TYPE.DELIVERY)
                Vue.set(store.state.Store.store.info.deliveryHours, data.currentDay, data.orderHours);
            }
            if (data.transportHours)
              Vue.set(store.state.Store.store.info.transportHours, data.currentDay, data.transportHours);

            Vue.set(
              store.state.Store.store.config,
              "pinRequiredAtDineinCheckout",
              data.pinRequiredAtDineinCheckout === true
            );
          }
          return data;
        });
    } else {
      return new Promise(resolve => {
        resolve(store.state.storeHours);
      });
    }
  },

  async askTableName(_store) {
    if (mDialog.tableNameDialog) {
      let om = store.state.Store.store.orderType.dinein;
      let tableName = await mDialog.tableNameDialog.open();
      if (tableName) {
        let res = await mRest.getTable({
          tableName: tableName,
          tableGroupID: om?.tableGroupID,
          sessionKey: _store == null ? undefined : _store.sessionKey,
        });
        if (res.result == "ok" && res.tables.length > 0) {
          let table = res.tables[0];
          return table;
        } else {
          mDialog.messageDialog.open(
            i18n.t("error_alert_title"),
            "",
            i18n.t("error_table_not_found", { table_name: tableName })
          );
          return null;
        }
      } else {
        return null;
      }
    }
  },

  comboScheduleInRange(ranges) {
    if (ranges == null) return true;

    const weekday = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const d = new Date();
    let day = d.getDay();
    let time = mUtils.toLocaleTime24String(d);

    let dateInRange = false;
    let timeInRange = false;
    let inRange = false;
    ranges.forEach(r => {
      if (r.dayOfWeek && r.time && !inRange) {
        let _df = r.dayOfWeek.substring(0, 3);
        let _dt = r.dayOfWeek.substring(4);
        let df = weekday.indexOf(_df);
        let dt = weekday.indexOf(_dt);

        let tf = r.time.substring(0, 5);
        let tt = r.time.substring(6);

        //console.log(df, dt, tf, tt);

        if (df < dt) {
          if (day >= df && day <= dt) dateInRange = true;
        } else if (df > dt) {
          if (day >= df || day <= dt) dateInRange = true;
        } else {
          if (day == df) dateInRange = true;
        }

        if (tf < tt) {
          if (time >= tf && time <= tt) timeInRange = true;
        } else if (tf > tt) {
          if (time >= tf || time <= tt) timeInRange = true;
        } else {
          timeInRange = true;
        }

        inRange = dateInRange && timeInRange;
      }
    });

    //console.log("comboScheduleInRange", ranges, day, time, inRange)
    return inRange;
  },
};
